<template>
  <div>
    <div class="gray-bg">
      <main-header ref="test"/>
    </div>
    <div class="aboutUs-bg">
      <nav-bar id="navBar" class="d-md-block d-none"/>
      <div v-if="currentBag.length>0" class="currentBag-bg-position pb-5">
        <div class="container currentBag-grayBorder p-0">
          <div class="gray-bg">
            <div class="text-center font-weight-bold py-5">سبد خرید</div>
          </div>
          <div class="row">
            <div class="col py-0">
              <!--              <div class="table-responsive text-center" id="currentBagTable">
                              <table class="table table-striped">
                                <thead>
                                <tr>
                                  <th>ردیف</th>
                                  <th>نام</th>
                                  <th>قیمت(تومان)</th>
                                  <th>درصد تخفیف</th>
                                  <th>جمع</th>
                                  <th>تعداد</th>
                                  <th></th>
                                </tr>
                                </thead>
                                <tbody v-for="(item,index) in currentBag" :key="item.ProductID">
                                <tr>
                                  <td>{{ index + 1 }}</td>
                                  <td>
                                    <div>
                                      <v-img :src="$replaceHttps(item.PictureUrl)" height="50"
                                             width="50" class="mx-auto"></v-img>
                                    </div>
                                    <div>
                                      {{ item.Name }}
                                    </div>
                                  </td>
                                  <td>{{ $numberWithCommas(item.Price) }}</td>
                                  <td>{{ item.Discount }}</td>
                                  <td>{{ $numberWithCommas(item.TotalRow) }}</td>
                                  <td>
                                    <span><i class="fas fa-plus pl-2  min-max-icon"
                                             @click="plusProduct(item.ProductID,item.NumberNeed,item.MinimumOrder)"></i></span>
                                    <span>{{ item.NumberNeed }}</span>
                                    <span><i class="fas fa-minus pr-3  min-max-icon"
                                             @click="minusProduct(item.ProductID,item.NumberNeed,item.MinimumOrder)"></i></span>
                                  </td>
                                  <td>
                                    <v-btn
                                        @click="deleteProduct(item.ProductID)"
                                        outlined
                                        rounded
                                        color="secondary"
                                        small>
                                          <span class=" black&#45;&#45;text"> <i
                                              class="fas fa-trash"></i> <span>حذف محصول</span></span>
                                    </v-btn>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>-->
              <v-data-table
                  id="dataTable"
                  :headers="headers"
                  :items="currentBag"
                  :items-per-page="5"
                  :light="true"
                  :mobile-breakpoint="680"
                  class="data-table"
                  fixed-header
                  item-key="productID"
              >
                <template v-slot:[`item.PictureUrl`]="{ item }">
                  <div class="py-3">
                    <v-img :src="$replaceHttps(item.PictureUrl)" class="mx-auto"
                           height="90" width="90"></v-img>
                  </div>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-btn
                      color="secondary"
                      outlined
                      rounded
                      small
                      @click="deleteProduct(item.ProductID)">
                            <span class="black--text"> <i
                                class="fas fa-trash"></i> <span>حذف محصول</span></span>
                  </v-btn>
                </template>
                <template v-slot:item.Price="{ item }">
                  <td>{{ $numberWithCommas(item.Price) }} تومان</td>
                </template>
                <template v-slot:item.TotalRow="{ item }">
                  <td>{{ $numberWithCommas(item.TotalRow) }} تومان</td>
                </template>
                <template v-slot:[`item.NumberNeed`]="{item }">
                  <span><i class="fas fa-plus pl-2  min-max-icon"
                           @click="plusProduct(item.ProductID,item.NumberNeed,item.MinimumOrder)"></i></span>
                  <span>{{ item.NumberNeed }}</span>
                  <span><i class="fas fa-minus pr-3  min-max-icon"
                           @click="minusProduct(item.ProductID,item.NumberNeed,item.MinimumOrder)"></i></span>
                </template>
              </v-data-table>
            </div>
          </div>
          <div class="footer-border-bottom">
            <div class="row pb-3" dir="ltr">
              <div class="col-sm-5 text-center mx-4">
                <span class="font-18"><span
                    class="second-color font-18">جمع فاکتور:</span> {{ $numberWithCommas(factorTotal) }} تومان</span>
                <v-text-field
                    v-model="discountCode"
                    class="input-border mt-5 "
                    dense
                    dir="rtl"
                    flat
                    hide-details
                    placeholder="ورود کد تخفیف"
                    solo
                ></v-text-field>
                <v-btn
                    block
                    class="mt-2 "
                    color="secondary"
                    @click="setDiscountCode"
                ><span class="black--text">ثبت کد</span>
                </v-btn>
                <div class="mt-4 font-16"><span class="second-color font-18"> قابل پرداخت:</span>
                  {{ $numberWithCommas(totalPrice) }} تومان
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-12">
                <div class="text-center">
                  از روی نقشه محلی که می خواهید محصول سفارش داده شده را تحویل بگیرید انتخاب نمایید
                </div>
                <div>
                  <v-btn class="loc-btn" icon @click="getCurrentLocation">
                    <i class="fas fa-location pl-1 pb-1 font19px primary-text"></i>
                  </v-btn>
                  <GmapMap
                      ref="mapRef"
                      :center="myCoordinates"
                      :options='{ fullscreenControl: false, mapTypeControl: false }'
                      :zoom="zoom"
                      style="height:500px"
                      @click="mark">
                    <GmapMarker
                        v-for='(marker,index) in markers'
                        :key="index"
                        :animation="2"
                        :clickable="true"
                        :position="marker"
                        @click="center=marker"/>
                  </GmapMap>
                </div>
              </div>

              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-6">
                    <div class="font-16">
                      نام
                    </div>
                    <v-text-field
                        v-model="name"
                        dense
                        dir="rtl"
                        flat
                        hide-details
                        outlined
                        placeholder="نام"
                    ></v-text-field>
                  </div>
                  <div class="col-6">
                    <div class="font-16">
                      نام خانوادگی
                    </div>
                    <v-text-field
                        v-model="family"
                        dense
                        dir="rtl"
                        flat
                        hide-details
                        outlined
                        placeholder="نام خانوادگی"
                    ></v-text-field>

                  </div>
                </div>

                <div class="font-16 mt-5">
                  آدرس دریافت محصول را وارد کنید
                </div>
                <div>
                  <v-textarea
                      v-model="userAddress"
                      class="mt-2"
                      name="input-7-4"
                      placeholder="آدرس نباید کمتر از 5 حرف باشد"
                      solo
                  ></v-textarea>
                </div>
                <div class="font-16">
                  در صورتی که سفارش برای شهرستان می باشد، مقصد و نام باربری را وارد نمایید
                </div>
                <div>
                  <v-textarea
                      v-model="userDescription"
                      class="mt-2"
                      name="input-7-4"
                      placeholder="اگر توضیح یا مطلب خاصی دارید وارد کنید"
                      solo
                  ></v-textarea>
                </div>
                <div class="d-flex justify-content-center">
                  <v-btn
                      class="mt-2 "
                      color="secondary"
                      @click="setOrder"
                  ><span class="black--text">ثبت سفارش</span>
                  </v-btn>
                  <v-btn
                      class="mt-2 "
                      color="secondary"
                      @click="goToBank"
                  ><span class="black--text">پرداخت آنلاین</span>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="container currentBag-position currentBag-grayBorder p-0">
        <div class="gray-bg">
          <div class="text-center font-weight-bold py-5">سبد خرید</div>
        </div>
        <div class="currentBag-text-bg text-center py-7">
          <div>{{ currentBagText }}</div>
        </div>
      </div>
    </div>

    <NavigationDrawer :drawer="drawer"/>
    <Footer></Footer>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-center">
          <v-btn class="secondary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showDeleteDialog"
        persistent
        width="500">
      <v-card class="text-center ">
        <v-card-title class="bg-darkGray">
          <v-btn color="secondary" icon small @click="showDeleteDialog = !showDeleteDialog">
            <i class="fas fa-times font-18 ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-3">
          <div class=" black--text font-16">آیا محصول از سبد خرید حذف شود؟</div>
        </v-card-text>
        <v-card-actions class="pt-1 pb-3 justify-content-center">
          <v-btn class="secondary" rounded @click="removeProduct()">
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import MainHeader from "./mainHeader";
import NavBar from "./navBar";
import Footer from "./Footer";
import NavigationDrawer from "./navigationDrawer";

export default {
  name: "currentBag",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {NavigationDrawer, Footer, NavBar, MainHeader},
  data: () => ({
    headers: [
      {text: 'عکس ', value: 'PictureUrl', sortable: false,},
      {text: 'نام', value: 'Name', sortable: false,},
      {text: 'قیمت(تومان)', value: 'Price', sortable: false,},
      {text: 'درصد تخفیف', value: 'Discount', sortable: false,},
      {text: 'جمع', value: 'TotalRow', sortable: false,},
      {text: 'تعداد', value: 'NumberNeed', sortable: false,},
      {text: '', value: 'action', sortable: false,},

    ],
    list: {},
    id: null,
    showDeleteDialog: false,
    drawer: false,
    currentBagText: 'محصولی در سبد خرید شما موجود نیست',
    currentBag: [],
    map: null,
    markers: [],
    center: {lat: 45.508, lng: -73.587},
    myCoordinates: {
      lat: 35.723524,
      lng: 51.396660
    },
    zoom: 10,
    text: "",
    discountCode: null,
    showdialog: false,
    currentPlace: null,
    showLoaderDialog: false,
    showResultDialog: false,
    factorTotal: null,
    totalPrice: null,
    dialogResult: null,
    userAddress: null,
    userDescription: null,
    name: null,
    family: null
  }),
  mounted () {
    this.getCurrentBagData()
    this.$refs.mapRef.$mapPromise.then(map => this.map = map);
  },
  created () {
    _this = this;
    this.$getLocation({})
        .then(coordinates => {
          this.myCoordinates = coordinates;
          this.markers.push(this.myCoordinates)
        })
        .catch(error => console.log(error));
  },
  methods: {
    deleteProduct (id) {
      this.showDeleteDialog = true
      this.id = id
    },
    getImgUrl (pic) {
      return require('../assets/img/' + pic)
    },
    mark (event) {
      if (this.markers.length > 0) {
        this.markers.pop()
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      } else {
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      }
    },
    showDialogMethod () {
      this.showdialog = true;
      this.init();
    },
    closeDialogMethod () {
      this.showdialog = true;
      this.destroyMap();
    },
    getCurrentLocation () {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push(this.myCoordinates)
              this.$refs.mapRef.$mapPromise.then(map => map.panTo(coordinates));

            } else {
              this.markers.push(this.myCoordinates)
            }
          })
          .catch(error => console.log(error));
    },
    setOrder () {
      if (this.userAddress !== null) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);
        console.log(this.$getUserData().token)
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("Address", this.userAddress);
        if (this.markers.length > 0) {
          urlencoded.append("Latitude", this.markers[0].lat);
          urlencoded.append("Longitude", this.markers[0].lng);
        }

        urlencoded.append("UserDescription", this.userDescription);

        if (this.name) {
          urlencoded.append("Name", this.name);
        }
        if (this.family) {
          urlencoded.append("Family", this.family);
        }

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Shopping/SetInvoiceWithCacheInPlace", requestOptions)
            .then(response => response.text())
            .then(result => {
              _this.showLoaderDialog = false;
              _this.dialogResult = result
              _this.showResultDialog = true;
              this.getCurrentBagData()

            })
            .catch(error => console.log('error', error));
      } else {
        _this.dialogResult = "وارد کردن آدرس الزامی است"
        _this.showResultDialog = true;
      }
    },
    getCurrentBagData () {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      console.log(this.$getUserData().token)
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/CurrentBag", requestOptions)
          .then(response => response.text())
          .then(result => {
            if (result.indexOf("محصولی در سبد خرید شما موجود نیست") > -1) {
              _this.currentBag = [];
              _this.factorTotal = 0;
              _this.totalPrice = 0;
              _this.discountCode = null;
              this.$refs.test.numberOrders = _this.currentBag.length
            } else {
              let json = JSON.parse(result)
              _this.currentBag = json.ListProduct
              console.log("_this.currentBag")
              console.log(_this.currentBag)
              _this.factorTotal = json.FactorAmount
              _this.totalPrice = json.TotalAmount
              _this.discountCode = json.DiscountCodeNumber
              window.$currentBagNav.getCurrentBagData()
            }
          })
          .catch(error => {
            console.log('error', error);
          });
    },
    plusProduct (id, numberNeed, minOrder) {
      _this.showLoaderDialog = true;
      let numberOrder = numberNeed + minOrder

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", id);
      urlencoded.append("ValueAmount", numberOrder);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/AddOrder", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.dialogResult = result
            _this.getCurrentBagData()

          })
          .catch(error => console.log('error', error));
    },
    minusProduct (id, numberNeed, minOrder) {
      _this.showLoaderDialog = true;
      let numberOrder = numberNeed - minOrder
      if (numberOrder < minOrder) {
        _this.showLoaderDialog = false;
        this.deleteProduct(id)
      } else {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("ProductID", id);
        urlencoded.append("ValueAmount", numberOrder);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Shopping/MinusOrder", requestOptions)
            .then(response => response.text())
            .then(result => {
              /*if (numberOrder > 0) {
                _this.showLoaderDialog = false;
                _this.dialogResult = result
              } else{
                _this.showLoaderDialog = false;
                _this.deleteProduct(id)
                window.$currentBagNav.getCurrentBagData()
              }*/
              if (numberOrder <= 0) {
                _this.showLoaderDialog = false;
                _this.dialogResult = result;
                this.id = id;
                _this.deleteProduct(id);
                window.$currentBagNav.getCurrentBagData()
              }

              _this.showLoaderDialog = false;


              this.getCurrentBagData()
            })
            .catch(error => console.log('error', error));
      }

    },
    removeProduct () {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProductID", this.id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/RemoveOrder", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showDeleteDialog = false;
            _this.showLoaderDialog = false;
            _this.dialogResult = result
            window.$currentBagNav.getCurrentBagData()
            _this.getCurrentBagData()
          })
          .catch(error => console.log('error', error));
    },
    setDiscountCode () {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("CodeNumber", this.discountCode);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Shopping/ValidateCode", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.dialogResult = json.Message;
            _this.showResultDialog = true
            _this.totalPrice = json.NewFactor;

          })
          .catch(error => console.log('error', error));
    },
    goToBank () {
      if (this.userAddress !== null) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("Address", this.userAddress);
        if (this.markers.length > 0) {
          urlencoded.append("Latitude", this.markers[0].lat);
          urlencoded.append("Longitude", this.markers[0].lng);
        }
        urlencoded.append("UserDescription", this.userDescription);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Shopping/GoToBank", requestOptions)
            .then(response => response.text())
            .then(result => {
              this.showLoaderDialog = false;
              this.$openLink(result)

            })
            .catch(error => console.log('error', error));
      } else {
        _this.dialogResult = "وارد کردن آدرس الزامی است"
        _this.showResultDialog = true;
      }

    },

  }
}
</script>

<style scoped>

</style>
